import FitHalfScreenDialogV2 from './src/index.vue';

export default FitHalfScreenDialogV2;
